<template>
  <v-expansion-panel-content class="elevation-1">
    <!-- The header of the category with a summary of the category stats -->
    <template #header>
      <v-category-header @click="setCurrentCategoryAndGetItems" :category="category" />
    </template>
    <v-container fluid class="my-0">
      <!-- The action buttons to save/clear the selections -->
      <v-category-actions :category="category" />
      <!-- The items of the group -->
      <v-items-grid :items="categoryItems" />
    </v-container>
  </v-expansion-panel-content>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import VCategoryActions from "./CategoryActions";
import VCategoryHeader from "./CategoryHeader";
import VItemsGrid from "./ItemsGrid";

export default {
  components: {
    VCategoryActions,
    VCategoryHeader,
    VItemsGrid
  },
  props: {
    /**
     * A category with sellerId, name and url.
     */
    category: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("classifier", [
      "currentCategory",
      "categoryItems",
      "categoryItemsCount"
    ])
  },
  methods: {
    ...mapActions("classifier", ["getCategoryItems"]),
    ...mapMutations("classifier", ["setCurrentCategory"]),
    setCurrentCategoryAndGetItems() {
      if (
        !this.currentCategory ||
        this.currentCategory.url !== this.category.url
      ) {
        this.setCurrentCategory(this.category);
        this.getCategoryItems();
      }
    }
  }
};
</script>